var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBrunoCoreBenefits5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2605_6770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3375 3.31761L16.1122 11.1832L6.16895 1.23993C10.4261 -0.938824 15.7736 -0.246262 19.3375 3.31761Z",
    fill: "#595AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3271 11.3274L23.215 27.8557L30.4641 20.6066L22.57 12.7126C22.9807 9.37074 21.9026 5.88266 19.3372 3.31738L11.3271 11.3274Z",
    fill: "#303183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3274 11.3267L25.5356 25.5349L20.6059 30.4645L12.7119 22.5705C9.37081 22.9804 5.88273 21.9023 3.31745 19.3369C-0.246538 15.7729 -0.938663 10.4265 1.23998 6.16895L8.86254 13.7915L11.3274 11.3267Z",
    fill: "#595AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6626 52.682L39.8878 44.8164L49.8311 54.7597C45.5738 56.9384 40.2265 56.2459 36.6626 52.682Z",
    fill: "#303183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6727 44.6719L32.7847 28.1436L25.5356 35.3926L33.4297 43.2866C33.019 46.6285 34.0971 50.1166 36.6625 52.6818L44.6727 44.6719Z",
    fill: "#595AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6725 44.672L30.4644 30.4638L35.394 25.5342L43.288 33.4282C46.6291 33.0183 50.1172 34.0964 52.6825 36.6618C56.2462 40.2255 56.9385 45.5721 54.7598 49.8296L47.1373 42.2071L44.6725 44.672Z",
    fill: "#303183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2416 2.75781L54.4739 3.99014C56.5072 6.02342 56.5072 9.35072 54.4739 11.384L51.4819 14.3761L43.459 9.44686L53.2416 2.75781Z",
    fill: "#FF6126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0095 1.52602L53.2418 2.75835L45.006 10.9942L41.6235 4.51808L44.6156 1.52602C46.6489 -0.507371 49.9762 -0.507371 52.0095 1.52602Z",
    fill: "#FF8151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5526 9.44629L51.4819 14.3756L46.5526 19.3048L38.5298 14.3756L46.5526 9.44629Z",
    fill: "#A3FDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6235 4.51758L46.5529 9.44689L40.0768 15.9229L36.6943 9.44689L41.6235 4.51758Z",
    fill: "#DBFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5238 49.9297L5.6065 54.1061L0.656738 55.3435L4.5238 49.9297Z",
    fill: "#000E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89421 50.3936L3.75041 52.2496L0.656738 55.3433L1.89421 50.3936Z",
    fill: "#116371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64602 44.8076L13.8015 52.0568L5.60658 54.1062L3.75049 52.25L9.64602 44.8076Z",
    fill: "#FFA07D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94275 42.1982L8.87239 47.1279L3.75025 52.25L1.89404 50.3939L3.94275 42.1982Z",
    fill: "#FFC0A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6236 14.376L46.553 19.3053L13.8014 52.0569L8.87207 47.1276L22.9276 28.4317L41.6236 14.376Z",
    fill: "#FFD15E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6948 9.44629L41.6239 14.3756L8.87179 47.1265L3.9427 42.1973L36.6948 9.44629Z",
    fill: "#FFEA7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2605_6770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBrunoCoreBenefits5);
export default __webpack_public_path__ + "static/media/products_bruno_core_benefits_5.f29be890eb62b4e55ec99336ec4f798a.svg";
export { ForwardRef as ReactComponent };